import api from '../utils/api';

// =====  partner =====

export const getAllPartnerBytype = async (type) => {
    try {
        const response = await api.get(`/partner/type/${type}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération des partenaires de type ${type}:`, error);
        throw new Error(error.response?.data?.message || `Impossible de récupérer les partenaires de type ${type}`);
    }
};

export const getPartnerByMail = async (mail) => {
    try {
        const response = await api.get(`/partner/email/${mail}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération des partenaires de mail ${mail}:`, error);
        throw new Error(error.response?.data?.message || `Impossible de récupérer les partenaires de mail ${mail}`);
    }
};


// ===== Fournisseurs (Suppliers) =====


export const getAllSuppliers = async () => {
    try {
        const response = await api.get('/partner/suppliers');
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des fournisseurs:', error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer les fournisseurs');
    }
};

export const getSupplierById = async (id) => {
    try {
        const response = await api.get(`/partner/suppliers/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération du fournisseur ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer le fournisseur');
    }
};

export const createSupplier = async (supplierData) => {
    try {
        const response = await api.post('/partner/suppliers', supplierData);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la création du fournisseur:', error);
        throw new Error(error.response?.data?.message || 'Impossible de créer le fournisseur');
    }
};

export const updateSupplier = async (id, supplierData) => {
    try {
        const response = await api.put(`/partner/suppliers/${id}`, supplierData);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la mise à jour du fournisseur ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de mettre à jour le fournisseur');
    }
};

export const deleteSupplier = async (id) => {
    try {
        const response = await api.delete(`/partner/suppliers/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la suppression du fournisseur ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de supprimer le fournisseur');
    }
};

export const deleteMultipleSuppliers = async (ids) => {
    try {
        const response = await api.post('/partner/suppliers/delete-multiple', { ids });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la suppression des fournisseurs:', error);
        throw new Error(error.response?.data?.message || 'Impossible de supprimer les fournisseurs');
    }
};

// ===== Distributeurs (Distributors) =====

export const getAllDistributors = async () => {
    try {
        const response = await api.get('/partner/distributors');
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des distributeurs:', error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer les distributeurs');
    }
};

export const getDistributorById = async (id) => {
    try {
        const response = await api.get(`/partner/distributors/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération du distributeur ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer le distributeur');
    }
};

export const createDistributor = async (distributorData) => {
    try {
        const response = await api.post('/partner/distributors', distributorData);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la création du distributeur:', error);
        throw new Error(error.response?.data?.message || 'Impossible de créer le distributeur');
    }
};

export const updateDistributor = async (id, distributorData) => {
    try {
        const response = await api.put(`/partner/distributors/${id}`, distributorData);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la mise à jour du distributeur ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de mettre à jour le distributeur');
    }
};

export const deleteDistributor = async (id) => {
    try {
        const response = await api.delete(`/partner/distributors/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la suppression du distributeur ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de supprimer le distributeur');
    }
};

export const deleteMultipleDistributors = async (ids) => {
    try {
        const response = await api.post('/partner/distributors/delete-multiple', { ids });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la suppression des distributeurs:', error);
        throw new Error(error.response?.data?.message || 'Impossible de supprimer les distributeurs');
    }
};

export const getDistributorPricesCurrentUser = async (distributorId) => {
    try {
        const response = await api.get(`/partner/distributors/${distributorId}/prices/current-user`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération des prix pour le distributeur ${distributorId}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer les prix');
    }
};

export const getDistributorPrices = async (distributorId) => {
    try {
        const response = await api.get(`/partner/distributors/${distributorId}/prices`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération des prix pour le distributeur ${distributorId}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer les prix');
    }
};

export const setProductPrice = async (distributorId, productId, price) => {
    try {
        const response = await api.post(`/partner/distributors/${distributorId}/prices/${productId}`, { price });
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la définition du prix:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de définir le prix');
    }
};

// ===== Détaillants (Retailers) =====

export const getAllRetailers = async () => {
    try {
        const response = await api.get('/partner/retailers');
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des détaillants:', error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer les détaillants');
    }
};

export const getRetailersByCommercial = async () => {
    try {
        const response = await api.get(`/partner/retailers/commercial`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération des détaillants pour le commercial:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer les détaillants');
    }
};

export const getRetailerById = async (id) => {
    try {
        const response = await api.get(`/partner/retailers/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération du détaillant ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer le détaillant');
    }
};

export const createRetailer = async (retailerData) => {
    try {
        const response = await api.post('/partner/retailers', retailerData);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la création du détaillant:', error);
        throw new Error(error.response?.data?.message || 'Impossible de créer le détaillant');
    }
};

export const updateRetailer = async (id, retailerData) => {
    try {
        const response = await api.put(`/partner/retailers/${id}`, retailerData);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la mise à jour du détaillant ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de mettre à jour le détaillant');
    }
};

export const deleteRetailer = async (id) => {
    try {
        const response = await api.delete(`/partner/retailers/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la suppression du détaillant ${id}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de supprimer le détaillant');
    }
};

export const deleteMultipleRetailers = async (ids) => {
    try {
        const response = await api.post('/partner/retailers/delete-multiple', { ids });
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la suppression des détaillants:', error);
        throw new Error(error.response?.data?.message || 'Impossible de supprimer les détaillants');
    }
};

export const assignRetailerToCommercial = async (retailerId, commercialUserId) => {
    try {
        const response = await api.post(`/partner/retailers/${retailerId}/assign`, { commercialUserId });
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de l'assignation du détaillant au commercial:`, error);
        throw new Error(error.response?.data?.message || 'Impossible d\'assigner le détaillant au commercial');
    }
};
